module.exports = __webpack_public_path__ + "static/media/no-results-auto_600.b9ffa5c9.jpg";